import { render, staticRenderFns } from "./LogList.vue?vue&type=template&id=0cb6ba67&scoped=true"
import script from "./LogList.vue?vue&type=script&lang=js"
export * from "./LogList.vue?vue&type=script&lang=js"
import style0 from "./LogList.vue?vue&type=style&index=0&id=0cb6ba67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb6ba67",
  null
  
)

export default component.exports